import React, { Fragment, useContext } from 'react';
import './FisherPortal.scss';
import {API} from '../../services/api'


import FamilyIcon from './AssetsFisherPortal/FisherPortal/FamilyIcon.svg';
import FishersIcon from './AssetsFisherPortal/FisherPortal/FishersIcon.png';
import commerceIcon from './AssetsFisherPortal/comercializadora.svg';

import FisherCardPhoto0 from './AssetsFisherPortal/FisherCardPlaceHolders/PlaceHolder0.png';


import UploadProduct from './AssetsFisherPortal/uploadProduct.svg';
import { useState } from 'react';
import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { uiContext } from '../common';

/**
 * Componente que renderiza los datos del usuario en el portal del pescador
 */
const RenderCards = (numberOfCards) => {

    let Cards = [];
    for (let i = 0; i < numberOfCards; i++) {
        Cards.push(<div className="fisherCard">
            <img className="fisherCardPhoto" src={FisherCardPhoto0} alt="" />
            <div className="fisherCardFieldContainer">
                <span className="fieldName">Pescador:</span>
                <span className="fieldAnswer">PlaceHolder</span>
            </div>
            <div className="fisherCardFieldContainer">
                <span className="fieldName">Celular:</span>
                <span className="fieldAnswer">PlaceHolder</span>
            </div>
            <div className="fisherCardFieldContainer">
                <span className="fieldName">Web:</span>
                <span className="fieldAnswer">PlaceHolder</span>
            </div>
            <div className="fisherCardFieldContainer">
                <span className="fieldName">Especies:</span>
                <span className="fieldAnswer">PlaceHolder</span>
            </div>

            <div className="buttonContainer">
                <button >Ver más</button>
            </div>
        </div>);
    }
    return Cards;
}

const FisherPortal = () => {
    /**
     * Componente que renderiza los productos de la región pasada por parametro en la ruta
     */
    const [profileType, SetProfileType] = useState("fisher");
    const [paginationIndex, setPaginationIndex] = useState(0);
    const [items, setItems] = useState([]);
    const history = useHistory();
    const uicontext = useContext(uiContext);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [content, setContent] = useState("");
    const [comments, setComments] = useState("");

    const [filter, setFilter] = useState(0);

    const {regionfilter} = useParams();

    useEffect(() => {
        //fisher
        //organization
        //commercial
        getPaginationItems();
        getLastComments();
    }, []);

    const getLastComments = () => {
        uicontext.showLoader(true);
        /**
         * Obtener ultimos comentarios
         * Se hace el llamado al servicio /comments/get-last-comments
         */
        API.getLastComments()
            .then(x => {
                setComments(x);
                uicontext.hideLoader();
            })
            .catch(x => {
                uicontext.hideLoader();
            })
    }

    const renderComments = () => {
        let commnetsToRender = [];


        for (let i = 0; i < comments.length; i++) {

            commnetsToRender.push(
                <div key={i} className="comment">
                    <div className="photoSection">
                        <img src={UploadProduct} alt="" />
                    </div>
                    <div className="contentSection">
                        <span className="commentTitle">{comments[i].authorName}</span>
                        <span className="commentContent">{comments[i].content}</span>
                    </div>
                </div>)

        }
        return commnetsToRender;
    }

    const getPaginationItems = () => {
        uicontext.showLoader(true); 
        
        /**
         * Obtener los ultimos productos
         * Se hace el llamado al servicio /products/get-last-products
         */
        API.putLastProducts(
            regionfilter.replace(/-/g, ' '),
            paginationIndex,
            30)
            .then(x => {
                setItems(x);
                uicontext.hideLoader();
            })
            .catch(x => {
                uicontext.hideLoader();
            })
    }

    const renderItems = () => {
        let cacheToRender = [];
        const getFilterName = () => {
            switch (filter) {
                case 1: return "ORGANIZATION";
                case 2: return "FISHER";
                case 3: return "MARKETER";
                default: return "NULL";
            }
        }


        for (let i = 0; i < items.length; i++) {
            if (items[i].user.type === getFilterName() || filter === 0) {
                cacheToRender.push(
                    <div key={i} className="fisherCard">
                        <div className="FisherCardContentContainer">
                            <img className="fisherCardPhoto" src={items[i].photoUrl} alt="" />
                            <div className="fisherCardFieldContainer">
                                {items[i].user.type === "FISHER" && <span className="fieldName">Pescador:</span>}
                                {items[i].user.type === "ORGANIZATION" && <span className="fieldName">Organizacion:</span>}
                                {items[i].user.type === "MARKETER" && <span className="fieldName">Comercializadora:</span>}

                                {items[i].user.type === "FISHER" && <span className="fieldAnswer">{items[i].user.name} {items[i].user.lastname}</span>}
                                {items[i].user.type !== "FISHER" && <span className="fieldAnswer">{items[i].user.businessLegalName}</span>}
                            </div>
                            {
                                (items[i].user.mobilePhone !== null || items[i].user.mobilePhone === "") &&
                                <div className="fisherCardFieldContainer">
                                    <Fragment>
                                        <span className="fieldName">Celular:</span>
                                        <span className="fieldAnswer">{items[i].user.mobilePhone}</span>
                                    </Fragment>
                                </div>
                            }

                            {
                                (items[i].regionKey !== null || items[i].regionKey === "") &&
                                <div className="fisherCardFieldContainer">
                                    <Fragment>
                                        <span className="fieldName">Region:</span>
                                        <span className="fieldAnswer">{items[i].regionKey}</span>
                                    </Fragment>
                                </div>
                            }

                            {
                                (items[i].user.sectorKey !== null || items[i].user.sectorKey === "") &&
                                <div className="fisherCardFieldContainer">
                                    <Fragment>
                                        <span className="fieldName">Caleta:</span>
                                        <span className="fieldAnswer">{items[i].user.sectorKey}</span>
                                    </Fragment>
                                </div>
                            }

                            <div className="fisherCardFieldContainer">
                                <span className="fieldName">Especies:</span>
                                <span className="fieldAnswer">{items[i].name}</span>
                            </div>
                            {
                                (items[i].user.website !== null || items[i].user.website === "") &&
                                <div className="fisherCardFieldContainer">
                                    <Fragment>
                                        <span className="fieldName">Web:</span>
                                        <span className="fieldAnswer">{items[i].user.website}</span>
                                    </Fragment>
                                </div>
                            }
                        </div>

                        <div className="buttonContainer">
                            <button onClick={() => { history.push("/perfil-visitante/" + items[i].userId) }} >Ver más</button>
                        </div>
                    </div>
                );
            }
        }

        return cacheToRender;
    }

    const sendComment = () => {
        uicontext.showLoader();
        /**
         * Comentar
         * Se hace el llamado al servicio /comments/register-comment
         */
        API.postRegisterComment({
            authorName: name,
            authorEmail: email,
            content: content
        })
        .then(x => {
            setName("");
            setEmail("");
            setContent("");
            getLastComments();
        })
        .catch(x => {
            uicontext.hideLoader();
        })
    }

    useEffect(() => {
    }, [filter])

    return (
        <div className="FisherPortalMasterContainer">
            <div className="subContainer">
                <div className="fisherPortal">
                    <span className="fisherPortalTitle">Portal del pescador</span>

                    <div onClick={() => { setFilter(filter === 1 ? 0 : 1); }} className={((filter !== 1 && filter !== 0) ? "fisherPortalSectionSelected " : "") + "fisherPortalSection fisherPortalSectionBlue"}>
                        <div className="iconContainer">
                            <img src={FamilyIcon} alt="" />
                            <span>Organizaciones</span>
                        </div>
                    </div>

                    <div onClick={() => { setFilter(filter === 2 ? 0 : 2); }} className={(filter !== 2 && filter !== 0 ? "fisherPortalSectionSelected " : "") + "fisherPortalSection fisherPortalSectionOrange"}>
                        <div className="iconContainer">
                            <img src={FishersIcon} alt="" />
                            <span>Pescadores y Pescadoras</span>
                        </div>
                    </div>

                    <div onClick={() => { setFilter(filter === 3 ? 0 : 3); }} className={(filter !== 3 && filter !== 0 ? "fisherPortalSectionSelected " : "") + "fisherPortalSection fisherPortalSectionCyan"}>
                        <div className="iconContainer">
                            <img src={commerceIcon} alt="" />
                            <span>Comercializadoras de la caleta</span>
                        </div>
                    </div>
                </div>

                <div className="fisherCardsContainer">
                    {renderItems()}

                    {/*<div className="ShowMore">
                        <button onClick={() => { getPaginationItems() }}>Conocer mas</button>
                    </div>*/}
                </div>



                {/* Comments */}
                <div className="commentsSection">
                    <div className="postCommentSubContainer">
                        <div className="photoSection">
                            <img src={UploadProduct} alt="" />
                            <span className="commnetSectionTitle">Comparte tu opinión</span>
                        </div>
                        <form className="contentSection" onSubmit={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            sendComment();
                        }}>
                            <input required value={name} onChange={(event) => { setName(event.target.value); }} className="nameInput" placeholder="Ingresa tu nombre" type="text" />
                            <input required value={email} onChange={(event) => { setEmail(event.target.value); }} className="mailInput" placeholder="Ingresa tu correo electrónico" type="text" />
                            <textarea required value={content} onChange={(event) => { setContent(event.target.value); }} placeholder="Tu opinión..."></textarea>
                            <input className="submitButton" type="submit" value="Enviar"></input>
                        </form>
                    </div>

                    <div className="listOfComments">
                        {renderComments(6)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FisherPortal;